import { PermissionEnum } from '../../../common/permissions/permissions.Enum';
import { getGroupPermissionFactory } from '../../../common/permissions/permissions.utils';
import { getUserManagementModuleName } from './user-management.permissions';

export class AccountTypesPermissions {
    static GroupName = `${getUserManagementModuleName()}.AccountTypes`;

    static getPermissions = getGroupPermissionFactory(AccountTypesPermissions.GroupName);

    static Permissions = {
        Read: AccountTypesPermissions.getPermissions(PermissionEnum.READ),
        ReadAll: AccountTypesPermissions.getPermissions(PermissionEnum.READ_ALL)
    };
}
